import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  toString1n9qg6fb0b5i8 as toString,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/AbstractMutableSet.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/AbstractMutableCollectionJs.mjs';
import {
  MutableEntry12w2i19w0igk5 as MutableEntry,
  Entry2xmjmyutzoq3p as Entry,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  equals2au1ep9vhcato as equals_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  fill3hcjvebk42tyx as fill,
  fill2542d4m9l93pn as fill_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function advance($this) {
  $l$loop: while ($this.orderIndex_1 < $this.this$0__1.insertionCount_1) {
    var idx = $this.this$0__1.insertionOrder_1[$this.orderIndex_1];
    if (idx >= 0 && !($this.this$0__1.keyStorage_1[idx] == null))
      break $l$loop;
    $this.orderIndex_1 = $this.orderIndex_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$KeySet$iterator$1Class;
function CaseInsensitiveMap$KeySet$iterator$1() {
  if (CaseInsensitiveMap$KeySet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.orderIndex_1 = 0;
        this.lastKey_1 = null;
        advance(this);
      }
      hasNext_bitz1p_k$() {
        return this.orderIndex_1 < this.this$0__1.insertionCount_1;
      }
      next_20eer_k$() {
        if (!this.hasNext_bitz1p_k$())
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var idx = this.this$0__1.insertionOrder_1[this.orderIndex_1];
        this.lastKey_1 = ensureNotNull(this.this$0__1.keyStorage_1[idx]);
        this.orderIndex_1 = this.orderIndex_1 + 1 | 0;
        advance(this);
        return ensureNotNull(this.lastKey_1);
      }
      remove_ldkf9o_k$() {
        var tmp0_elvis_lhs = this.lastKey_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.this$0__1.remove_z05dva_k$(key);
        this.lastKey_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$KeySet$iterator$1Class = $;
  }
  return CaseInsensitiveMap$KeySet$iterator$1Class;
}
function advance_0($this) {
  $l$loop: while ($this.orderIndex_1 < $this.this$0__1.insertionCount_1) {
    var idx = $this.this$0__1.insertionOrder_1[$this.orderIndex_1];
    if (idx >= 0 && !($this.this$0__1.keyStorage_1[idx] == null))
      break $l$loop;
    $this.orderIndex_1 = $this.orderIndex_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$ValueCollection$iterator$1Class;
function CaseInsensitiveMap$ValueCollection$iterator$1() {
  if (CaseInsensitiveMap$ValueCollection$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.orderIndex_1 = 0;
        this.lastKey_1 = null;
        advance_0(this);
      }
      hasNext_bitz1p_k$() {
        return this.orderIndex_1 < this.this$0__1.insertionCount_1;
      }
      next_20eer_k$() {
        if (!this.hasNext_bitz1p_k$())
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var idx = this.this$0__1.insertionOrder_1[this.orderIndex_1];
        this.lastKey_1 = ensureNotNull(this.this$0__1.keyStorage_1[idx]);
        var tmp = this.this$0__1.valueStorage_1[idx];
        var result = !(tmp == null) ? tmp : THROW_CCE();
        this.orderIndex_1 = this.orderIndex_1 + 1 | 0;
        advance_0(this);
        return result;
      }
      remove_ldkf9o_k$() {
        var tmp0_elvis_lhs = this.lastKey_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.this$0__1.remove_z05dva_k$(key);
        this.lastKey_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$ValueCollection$iterator$1Class = $;
  }
  return CaseInsensitiveMap$ValueCollection$iterator$1Class;
}
function advance_1($this) {
  $l$loop: while ($this.orderIndex_1 < $this.this$0__1.insertionCount_1) {
    var idx = $this.this$0__1.insertionOrder_1[$this.orderIndex_1];
    if (idx >= 0 && !($this.this$0__1.keyStorage_1[idx] == null))
      break $l$loop;
    $this.orderIndex_1 = $this.orderIndex_1 + 1 | 0;
  }
}
var CaseInsensitiveMap$EntrySet$iterator$1Class;
function CaseInsensitiveMap$EntrySet$iterator$1() {
  if (CaseInsensitiveMap$EntrySet$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
        this.orderIndex_1 = 0;
        this.lastKey_1 = null;
        advance_1(this);
      }
      hasNext_bitz1p_k$() {
        return this.orderIndex_1 < this.this$0__1.insertionCount_1;
      }
      next_20eer_k$() {
        if (!this.hasNext_bitz1p_k$())
          throw NoSuchElementException().new_kotlin_NoSuchElementException_wy3d4q_k$();
        var idx = this.this$0__1.insertionOrder_1[this.orderIndex_1];
        this.lastKey_1 = ensureNotNull(this.this$0__1.keyStorage_1[idx]);
        var tmp = ensureNotNull(this.lastKey_1);
        var tmp_0 = this.this$0__1.valueStorage_1[idx];
        var entry = new (MapEntry())(this.this$0__1, tmp, !(tmp_0 == null) ? tmp_0 : THROW_CCE());
        this.orderIndex_1 = this.orderIndex_1 + 1 | 0;
        advance_1(this);
        return entry;
      }
      remove_ldkf9o_k$() {
        var tmp0_elvis_lhs = this.lastKey_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('next() must be called before remove()');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var key = tmp;
        this.this$0__1.remove_z05dva_k$(key);
        this.lastKey_1 = null;
      }
    }
    initMetadataForClass($);
    CaseInsensitiveMap$EntrySet$iterator$1Class = $;
  }
  return CaseInsensitiveMap$EntrySet$iterator$1Class;
}
function caseInsensitiveHashCode($this, s) {
  var h = 0;
  var inductionVariable = 0;
  var last = s.length;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = imul(31, h);
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_0 = charCodeAt(s, i);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$1 = toString(this_0).toLowerCase();
      // Inline function 'kotlin.code' call
      var this_1 = charCodeAt(tmp$ret$1, 0);
      h = tmp + Char__toInt_impl_vasixd(this_1) | 0;
    }
     while (inductionVariable < last);
  return h;
}
function putWithoutTrackingOrderReturnIndex($this, key, value) {
  var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
  var index = hash & ($this.keyStorage_1.length - 1 | 0);
  while (true) {
    var existingKey = $this.keyStorage_1[index];
    if (existingKey == null) {
      $this.keyStorage_1[index] = key;
      $this.valueStorage_1[index] = value;
      $this._size_1 = $this._size_1 + 1 | 0;
      return index;
    }
    if (equals(existingKey, key, true)) {
      $this.valueStorage_1[index] = value;
      return index;
    }
    index = (index + 1 | 0) & ($this.keyStorage_1.length - 1 | 0);
  }
}
function findIndex($this, key) {
  if ($this._size_1 === 0)
    return -1;
  var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
  var index = hash & ($this.keyStorage_1.length - 1 | 0);
  while (true) {
    var existingKey = $this.keyStorage_1[index];
    if (existingKey == null)
      return -1;
    if (equals(existingKey, key, true))
      return index;
    index = (index + 1 | 0) & ($this.keyStorage_1.length - 1 | 0);
  }
}
function ensureCapacity($this) {
  if (imul($this._size_1, 4) >= imul($this.keyStorage_1.length, 3)) {
    resize($this, imul($this.keyStorage_1.length, 2));
  }
}
function resize($this, newCapacity) {
  var oldKeys = $this.keyStorage_1;
  var oldValues = $this.valueStorage_1;
  var oldInsertionOrder = $this.insertionOrder_1;
  var oldInsertionCount = $this.insertionCount_1;
  var tmp = $this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp.keyStorage_1 = Array(newCapacity);
  var tmp_0 = $this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp_0.valueStorage_1 = Array(newCapacity);
  var tmp_1 = $this;
  var tmp_2 = 0;
  var tmp_3 = new Int32Array(newCapacity);
  while (tmp_2 < newCapacity) {
    tmp_3[tmp_2] = -1;
    tmp_2 = tmp_2 + 1 | 0;
  }
  tmp_1.insertionOrder_1 = tmp_3;
  $this._size_1 = 0;
  $this.insertionCount_1 = 0;
  var inductionVariable = 0;
  if (inductionVariable < oldInsertionCount)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var oldIndex = oldInsertionOrder[i];
      if (oldIndex >= 0 && !(oldKeys[oldIndex] == null)) {
        var tmp_4 = ensureNotNull(oldKeys[oldIndex]);
        var tmp_5 = oldValues[oldIndex];
        $this.put_1pa1tm_k$(tmp_4, !(tmp_5 == null) ? tmp_5 : THROW_CCE());
      }
    }
     while (inductionVariable < oldInsertionCount);
}
function compactInsertionOrder($this) {
  if ($this.insertionCount_1 === 0)
    return Unit_instance;
  var writeIndex = 0;
  var inductionVariable = 0;
  var last = $this.insertionCount_1;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var idx = $this.insertionOrder_1[i];
      if (idx >= 0 && !($this.keyStorage_1[idx] == null)) {
        var tmp = $this.insertionOrder_1;
        var _unary__edvuaz = writeIndex;
        writeIndex = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = idx;
      }
    }
     while (inductionVariable < last);
  var inductionVariable_0 = writeIndex;
  var last_0 = $this.insertionOrder_1.length;
  if (inductionVariable_0 < last_0)
    do {
      var i_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      $this.insertionOrder_1[i_0] = -1;
    }
     while (inductionVariable_0 < last_0);
  $this.insertionCount_1 = writeIndex;
}
var KeySetClass;
function KeySet() {
  if (KeySetClass === VOID) {
    class $ extends AbstractMutableSet() {
      constructor($outer) {
        return new.target.new_io_ktor_util_CaseInsensitiveMap_KeySet_wzuxad_k$($outer);
      }
      static new_io_ktor_util_CaseInsensitiveMap_KeySet_wzuxad_k$($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        return this.new_kotlin_collections_AbstractMutableSet_hvoaax_k$($box);
      }
      get_size_woubt6_k$() {
        return this.$this_1._size_1;
      }
      add_2lb1a1_k$(element) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$('CaseInsensitiveMap.keys does not support add');
      }
      add_utx5q5_k$(element) {
        return this.add_2lb1a1_k$((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      contains_zh0gsb_k$(element) {
        return this.$this_1.containsKey_w445h6_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!(!(element == null) ? typeof element === 'string' : false))
          return false;
        return this.contains_zh0gsb_k$((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      iterator_jk1svi_k$() {
        return new (CaseInsensitiveMap$KeySet$iterator$1())(this.$this_1);
      }
    }
    initMetadataForClass($, 'KeySet');
    KeySetClass = $;
  }
  return KeySetClass;
}
var ValueCollectionClass;
function ValueCollection() {
  if (ValueCollectionClass === VOID) {
    class $ extends AbstractMutableCollection() {
      constructor($outer) {
        return new.target.new_io_ktor_util_CaseInsensitiveMap_ValueCollection_bv2pht_k$($outer);
      }
      static new_io_ktor_util_CaseInsensitiveMap_ValueCollection_bv2pht_k$($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        return this.new_kotlin_collections_AbstractMutableCollection_8hg8bd_k$($box);
      }
      get_size_woubt6_k$() {
        return this.$this_1._size_1;
      }
      add_tulrhs_k$(element) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$('CaseInsensitiveMap.values does not support add');
      }
      add_utx5q5_k$(element) {
        return this.add_tulrhs_k$(!(element == null) ? element : THROW_CCE());
      }
      iterator_jk1svi_k$() {
        return new (CaseInsensitiveMap$ValueCollection$iterator$1())(this.$this_1);
      }
    }
    initMetadataForClass($, 'ValueCollection');
    ValueCollectionClass = $;
  }
  return ValueCollectionClass;
}
var EntrySetClass;
function EntrySet() {
  if (EntrySetClass === VOID) {
    class $ extends AbstractMutableSet() {
      constructor($outer) {
        return new.target.new_io_ktor_util_CaseInsensitiveMap_EntrySet_eor0t7_k$($outer);
      }
      static new_io_ktor_util_CaseInsensitiveMap_EntrySet_eor0t7_k$($outer, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        return this.new_kotlin_collections_AbstractMutableSet_hvoaax_k$($box);
      }
      get_size_woubt6_k$() {
        return this.$this_1._size_1;
      }
      add_oz0yfa_k$(element) {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$('CaseInsensitiveMap.entries does not support add');
      }
      add_utx5q5_k$(element) {
        return this.add_oz0yfa_k$((!(element == null) ? isInterface(element, MutableEntry()) : false) ? element : THROW_CCE());
      }
      iterator_jk1svi_k$() {
        return new (CaseInsensitiveMap$EntrySet$iterator$1())(this.$this_1);
      }
    }
    initMetadataForClass($, 'EntrySet');
    EntrySetClass = $;
  }
  return EntrySetClass;
}
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor($outer, key, _value) {
        this.$this_1 = $outer;
        this.key_1 = key;
        this._value_1 = _value;
      }
      get_key_18j28a_k$() {
        return this.key_1;
      }
      get_value_j01efc_k$() {
        return this._value_1;
      }
      equals(other) {
        if (!(!(other == null) ? isInterface(other, Entry()) : false))
          return false;
        return equals_0(this.key_1, other.get_key_18j28a_k$()) && equals_0(this.get_value_j01efc_k$(), other.get_value_j01efc_k$());
      }
      hashCode() {
        return getStringHashCode(this.key_1) ^ hashCode(this.get_value_j01efc_k$());
      }
      toString() {
        return this.key_1 + '=' + toString_0(this.get_value_j01efc_k$());
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [MutableEntry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.INITIAL_CAPACITY_1 = 8;
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.EMPTY_STRING_ARRAY_1 = [];
        var tmp_0 = this;
        // Inline function 'kotlin.emptyArray' call
        tmp_0.EMPTY_ANY_ARRAY_1 = [];
        this.EMPTY_INT_ARRAY_1 = new Int32Array(0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CaseInsensitiveMapClass;
function CaseInsensitiveMap() {
  if (CaseInsensitiveMapClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance();
        this.keyStorage_1 = Companion_getInstance().EMPTY_STRING_ARRAY_1;
        this.valueStorage_1 = Companion_getInstance().EMPTY_ANY_ARRAY_1;
        this._size_1 = 0;
        this.insertionOrder_1 = Companion_getInstance().EMPTY_INT_ARRAY_1;
        this.insertionCount_1 = 0;
        this.cachedKeySet_1 = null;
        this.cachedEntrySet_1 = null;
        this.cachedValueCollection_1 = null;
      }
      get_size_woubt6_k$() {
        return this._size_1;
      }
      containsKey_w445h6_k$(key) {
        return findIndex(this, key) >= 0;
      }
      containsKey_aw81wo_k$(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return false;
        return this.containsKey_w445h6_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      get_6bo4tg_k$(key) {
        var index = findIndex(this, key);
        return index >= 0 ? this.valueStorage_1[index] : null;
      }
      get_wei43m_k$(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.get_6bo4tg_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      isEmpty_y1axqb_k$() {
        return this._size_1 === 0;
      }
      clear_j9egeb_k$() {
        if (this._size_1 > 0) {
          fill(this.keyStorage_1, null);
          fill(this.valueStorage_1, null);
          fill_0(this.insertionOrder_1, -1);
          this._size_1 = 0;
          this.insertionCount_1 = 0;
        }
      }
      put_1pa1tm_k$(key, value) {
        if (this.keyStorage_1 === Companion_getInstance().EMPTY_STRING_ARRAY_1) {
          var tmp = this;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp.keyStorage_1 = Array(8);
          var tmp_0 = this;
          // Inline function 'kotlin.arrayOfNulls' call
          tmp_0.valueStorage_1 = Array(8);
          var tmp_1 = this;
          var tmp_2 = 0;
          var tmp_3 = new Int32Array(8);
          while (tmp_2 < 8) {
            tmp_3[tmp_2] = -1;
            tmp_2 = tmp_2 + 1 | 0;
          }
          tmp_1.insertionOrder_1 = tmp_3;
        }
        var hash = caseInsensitiveHashCode(Companion_getInstance(), key);
        var index = hash & (this.keyStorage_1.length - 1 | 0);
        while (true) {
          var existingKey = this.keyStorage_1[index];
          if (existingKey == null) {
            ensureCapacity(this);
            index = hash & (this.keyStorage_1.length - 1 | 0);
            while (!(this.keyStorage_1[index] == null)) {
              index = (index + 1 | 0) & (this.keyStorage_1.length - 1 | 0);
            }
            if (this.insertionCount_1 === this.insertionOrder_1.length) {
              compactInsertionOrder(this);
            }
            this.keyStorage_1[index] = key;
            this.valueStorage_1[index] = value;
            var tmp_4 = this.insertionOrder_1;
            var _unary__edvuaz = this.insertionCount_1;
            this.insertionCount_1 = _unary__edvuaz + 1 | 0;
            tmp_4[_unary__edvuaz] = index;
            this._size_1 = this._size_1 + 1 | 0;
            return null;
          }
          if (equals(existingKey, key, true)) {
            var oldValue = this.valueStorage_1[index];
            this.valueStorage_1[index] = value;
            return oldValue;
          }
          index = (index + 1 | 0) & (this.keyStorage_1.length - 1 | 0);
        }
      }
      put_4fpzoq_k$(key, value) {
        var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
        return this.put_1pa1tm_k$(tmp, !(value == null) ? value : THROW_CCE());
      }
      putAll_qpg2h7_k$(from) {
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = from.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.collections.component1' call
          var key = element.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var value = element.get_value_j01efc_k$();
          this.put_1pa1tm_k$(key, value);
        }
      }
      putAll_wgg6cj_k$(from) {
        return this.putAll_qpg2h7_k$(from);
      }
      remove_z05dva_k$(key) {
        var index = findIndex(this, key);
        if (index < 0)
          return null;
        var oldValue = this.valueStorage_1[index];
        var inductionVariable = 0;
        var last = this.insertionCount_1;
        if (inductionVariable < last)
          $l$loop: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.insertionOrder_1[i] === index) {
              this.insertionOrder_1[i] = -1;
              break $l$loop;
            }
          }
           while (inductionVariable < last);
        this.keyStorage_1[index] = null;
        this.valueStorage_1[index] = null;
        this._size_1 = this._size_1 - 1 | 0;
        var nextIndex = (index + 1 | 0) & (this.keyStorage_1.length - 1 | 0);
        while (!(this.keyStorage_1[nextIndex] == null)) {
          var rehashKey = ensureNotNull(this.keyStorage_1[nextIndex]);
          var rehashValue = this.valueStorage_1[nextIndex];
          var oldRehashIndex = nextIndex;
          this.keyStorage_1[nextIndex] = null;
          this.valueStorage_1[nextIndex] = null;
          this._size_1 = this._size_1 - 1 | 0;
          var newIndex = putWithoutTrackingOrderReturnIndex(this, rehashKey, !(rehashValue == null) ? rehashValue : THROW_CCE());
          var inductionVariable_0 = 0;
          var last_0 = this.insertionCount_1;
          if (inductionVariable_0 < last_0)
            $l$loop_0: do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (this.insertionOrder_1[i_0] === oldRehashIndex) {
                this.insertionOrder_1[i_0] = newIndex;
                break $l$loop_0;
              }
            }
             while (inductionVariable_0 < last_0);
          nextIndex = (nextIndex + 1 | 0) & (this.keyStorage_1.length - 1 | 0);
        }
        return oldValue;
      }
      remove_gppy8k_k$(key) {
        if (!(!(key == null) ? typeof key === 'string' : false))
          return null;
        return this.remove_z05dva_k$((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
      }
      get_keys_wop4xp_k$() {
        var tmp0_elvis_lhs = this.cachedKeySet_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = KeySet().new_io_ktor_util_CaseInsensitiveMap_KeySet_wzuxad_k$(this);
          this.cachedKeySet_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      get_entries_p20ztl_k$() {
        var tmp0_elvis_lhs = this.cachedEntrySet_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = EntrySet().new_io_ktor_util_CaseInsensitiveMap_EntrySet_eor0t7_k$(this);
          this.cachedEntrySet_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      get_values_ksazhn_k$() {
        var tmp0_elvis_lhs = this.cachedValueCollection_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = ValueCollection().new_io_ktor_util_CaseInsensitiveMap_ValueCollection_bv2pht_k$(this);
          this.cachedValueCollection_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(other instanceof CaseInsensitiveMap()))
          return false;
        if (!(other.get_size_woubt6_k$() === this._size_1))
          return false;
        var inductionVariable = 0;
        var last = this.keyStorage_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var k = this.keyStorage_1[i];
            if (!(k == null)) {
              var v = this.valueStorage_1[i];
              if (!equals_0(other.get_6bo4tg_k$(k), v))
                return false;
            }
          }
           while (inductionVariable <= last);
        return true;
      }
      hashCode() {
        var result = 0;
        var inductionVariable = 0;
        var last = this.keyStorage_1.length - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var k = this.keyStorage_1[i];
            if (!(k == null)) {
              var tmp = result;
              var tmp_0 = caseInsensitiveHashCode(Companion_getInstance(), k);
              var tmp0_safe_receiver = this.valueStorage_1[i];
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
              result = tmp + (tmp_0 ^ (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) | 0;
            }
          }
           while (inductionVariable <= last);
        return result;
      }
    }
    initMetadataForClass($, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap()]);
    CaseInsensitiveMapClass = $;
  }
  return CaseInsensitiveMapClass;
}
//region block: exports
export {
  CaseInsensitiveMap as CaseInsensitiveMap3bv985x2xrppt,
};
//endregion

//# sourceMappingURL=CaseInsensitiveMap.mjs.map
